module.exports = __webpack_public_path__ + "static/media/1f1f1-1f1f7.0ac3af6c.svg";